import { FC } from 'react'

export const PerformCtaPage: FC = () => {
  return null
}
